(function () {
  'use strict';

  if (window.__nestMrcFeeCartLineResync20260709 === 'v2-fast-amount-event') return;
  window.__nestMrcFeeCartLineResync20260709 = 'v2-fast-amount-event';

  var feeVariantId = 39273096544337;
  var feeProductId = 6543483142225;
  var feeUnitCents = 1800;
  var timer = null;
  var running = false;
  var pending = false;
  var rawFetch = window.fetch ? window.fetch.bind(window) : null;
  var cartRootSelector = '.cart-modal,#CartDrawer,.cart-drawer,.drawer--cart,.ajax-cart,.ajaxcart,[data-cart-drawer],[data-cart-container],form[action*="/cart"]';
  var controlSelector = 'button,a,input,select,textarea,[role="button"],[data-cart-remove],[href*="/cart/change"],[name="updates[]"],[data-quantity-input],[class*="qty" i],[class*="quantity" i]';

  function textOf(item) { return [item && item.product_title, item && item.title, item && item.handle, item && item.url, item && item.product_type, item && item.vendor].join(' ').toLowerCase(); }
  function propsOf(item) { return item && item.properties && typeof item.properties === 'object' ? item.properties : {}; }

  function isMrcFee(item) {
    var props = propsOf(item);
    var text = textOf(item);
    return Number(item && item.variant_id) === feeVariantId || Number(item && item.product_id) === feeProductId || String(props.type || '').toLowerCase() === 'fee' || text.indexOf('mrc recycling fee') > -1 || text.indexOf('mattress recycling fee') > -1;
  }

  function isCompanion(item) {
    var text = textOf(item);
    return isMrcFee(item) || text.indexOf('lifetime renewal exchange') > -1 || text.indexOf('extend protection') > -1 || text.indexOf('protection plan') > -1;
  }

  function isEligibleMattress(item) {
    var text;
    if (!item || Number(item.quantity || 0) <= 0 || isCompanion(item)) return false;
    text = textOf(item);
    return text.indexOf('mattress') > -1 || text.indexOf('sparrow') > -1 || text.indexOf('owl') > -1 || text.indexOf('raven') > -1 || text.indexOf('puffin') > -1 || text.indexOf('starling') > -1;
  }

  function eligibleQty(cart) {
    return (cart && cart.items || []).reduce(function (sum, item) { return sum + (isEligibleMattress(item) ? Number(item.quantity || 0) : 0); }, 0);
  }

  function feeItems(cart) { return (cart && cart.items || []).filter(isMrcFee); }
  function feeQty(cart) { return feeItems(cart).reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0); }
  function feeCents(cart) { return feeItems(cart).reduce(function (sum, item) { return sum + Number(item.final_line_price || 0); }, 0); }

  function desiredNote(cart) {
    var cents = feeCents(cart);
    var first = feeItems(cart)[0];
    var unit = first ? Number(first.final_price || first.price || feeUnitCents) : feeUnitCents;
    var totalDollars = Math.round(cents / 100);
    if (cents <= 0) return '';
    return 'Recycling Fee: $' + (unit / 100).toFixed(2) + ' | MRC:111110-' + totalDollars + '-CA';
  }

  function emitAmountRefresh(reason, result) {
    var detail = Object.assign({ reason: reason || 'sync', at: Date.now() }, result || {});
    window.__nestMrcFeeCartLineResyncLastEvent = detail;
    try { window.dispatchEvent(new CustomEvent('nest:mrc-fee-line-resynced', { detail: detail })); } catch (error) {}
    try { document.dispatchEvent(new CustomEvent('nest:mrc-fee-line-resynced', { detail: detail })); } catch (error) {}
  }

  function fetchCart(reason) {
    if (!rawFetch) return Promise.reject(new Error('fetch unavailable'));
    return rawFetch('/cart.js?mrc_raw=1&mrc_line_resync=1&t=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
      .then(function (response) { if (!response.ok) throw new Error('cart read failed: ' + response.status); return response.json(); })
      .then(function (cart) {
        window.__nestMrcFeeCartLineResyncLastRead = { at: Date.now(), reason: reason || 'read', expectedQty: eligibleQty(cart), mrcLineCount: feeItems(cart).length, mrcQuantity: feeQty(cart), mrcTotalCents: feeCents(cart) };
        return cart;
      });
  }

  function changeLine(id, quantity) {
    return rawFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' }, credentials: 'same-origin', body: 'id=' + encodeURIComponent(id) + '&quantity=' + encodeURIComponent(quantity) })
      .then(function (response) { if (!response.ok) throw new Error('fee line change failed: ' + response.status); return response.json(); });
  }

  function addFee(quantity) {
    return rawFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' }, credentials: 'same-origin', body: 'id=' + encodeURIComponent(feeVariantId) + '&quantity=' + encodeURIComponent(quantity) + '&properties%5Btype%5D=fee' })
      .then(function (response) { if (!response.ok) throw new Error('fee line add failed: ' + response.status); return response.json(); });
  }

  function updateNote(cart) {
    var note = desiredNote(cart);
    if (!note || String(cart && cart.note || '') === note) return Promise.resolve(cart);
    return rawFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' }, credentials: 'same-origin', body: 'note=' + encodeURIComponent(note) })
      .then(function (response) { if (!response.ok) throw new Error('fee note update failed: ' + response.status); return response.json(); });
  }

  function sync(reason) {
    if (!rawFetch) return;
    if (running) { pending = true; return; }
    running = true;
    pending = false;

    fetchCart(reason).then(function (cart) {
      var expected = eligibleQty(cart);
      var fees = feeItems(cart);
      var current = feeQty(cart);
      var actions = [];
      window.__nestMrcFeeCartLineResyncLastState = { at: Date.now(), reason: reason || 'sync', expectedQty: expected, mrcLineCount: fees.length, mrcQuantity: current, mrcTotalCents: feeCents(cart) };

      if (expected <= 0) {
        fees.forEach(function (item) { actions.push(changeLine(item.key || item.variant_id, 0)); });
      } else if (!fees.length) {
        actions.push(addFee(expected));
      } else if (current !== expected || fees.length > 1) {
        fees.forEach(function (item, index) { actions.push(changeLine(item.key || item.variant_id, index === 0 ? expected : 0)); });
      }

      if (!actions.length) {
        return updateNote(cart).then(function () { return { changed: false, expected: expected, current: current, lines: fees.length, cents: feeCents(cart) }; });
      }

      return Promise.all(actions).then(function () { return fetchCart('after ' + (reason || 'sync')); }).then(function (nextCart) {
        return updateNote(nextCart).then(function () { return { changed: true, expected: expected, before: current, after: feeQty(nextCart), lines: feeItems(nextCart).length, cents: feeCents(nextCart) }; });
      });
    }).then(function (result) {
      window.__nestMrcFeeCartLineResyncLastApply = Object.assign({ at: Date.now(), reason: reason || 'sync' }, result || {});
      emitAmountRefresh(reason, result);
    }).catch(function (error) {
      window.__nestMrcFeeCartLineResyncLastError = error && error.message ? error.message : String(error);
    }).finally(function () {
      running = false;
      if (pending) schedule('pending', 80);
    });
  }

  function schedule(reason, delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { sync(reason); }, typeof delay === 'number' ? delay : 180);
  }

  function scheduleSeries(reason) {
    schedule(reason, 60);
    [320, 900, 1800].forEach(function (delay) { window.setTimeout(function () { sync(reason + ' +' + delay); }, delay); });
  }

  function cartControl(target) { return target && target.closest && target.closest(cartRootSelector) && target.closest(controlSelector); }

  function patchFetch() {
    if (!window.fetch || window.fetch.__nestMrcFeeCartLineResync20260709) return;
    rawFetch = window.fetch.bind(window);
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : input && input.url;
      return rawFetch.apply(this, arguments).then(function (response) {
        if (/\/cart\/(add|change|update)(?:\.js)?(?:\?|$)/.test(String(url || '')) && !/mrc_line_resync=1/.test(String(url || ''))) scheduleSeries('after fetch ' + url);
        return response;
      });
    };
    window.fetch.__nestMrcFeeCartLineResync20260709 = true;
  }

  function bind() {
    patchFetch();
    scheduleSeries('initial');
    document.addEventListener('click', function (event) { if (cartControl(event.target)) scheduleSeries('cart click'); }, true);
    document.addEventListener('change', function (event) { if (cartControl(event.target)) scheduleSeries('cart change'); }, true);
    document.addEventListener('input', function (event) { if (cartControl(event.target)) scheduleSeries('cart input'); }, true);
    ['refreshAjaxCart', 'refreshCart', 'cart:refresh'].forEach(function (eventName) {
      document.addEventListener(eventName, function () { scheduleSeries(eventName); }, true);
      window.addEventListener(eventName, function () { scheduleSeries(eventName); }, true);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})();